import * as P from "fp-ts-routing";

export type CompareRoute = {};

export const comparePageMatch = P.lit("compare");
